RivalIQ.module('graph', function (graph, App, Backbone, Marionette, $, _, d3) {

    'use strict';

    SparkBar.prototype = new graph.Graph();

    function SparkBar() {
        this.base = graph.Graph;
        this.base();
        this.maxRows = 30;
        this.height = 80;
        this.width = 180;
        this.margin.right = 30;
        this.margin.left = 60;
        this.margin.top = 30;
        this.margin.bottom = 10;
        this.zeroThickness = 2;
        this.shouldRenderAxis = true;
        this.shouldRenderYou = true;
        this.youText = 'You';
    }

    graph.SparkBar = SparkBar;

    SparkBar.prototype.render = function () {

        const me = this;
        const isReadOnly = RivalIQ.state.user.isReadOnly();
        me.mouseOverCompany = null;
        this.clearRendering();
        if (!this.shouldRenderAxis) {
            this.margin.right = 5;
            this.margin.left = 5;
            this.margin.top = 11;
            this.margin.bottom = 20;
        }
        const width = this.width - this.margin.right - this.margin.left;
        const height = this.height - this.margin.top - this.margin.bottom - this.zeroThickness;

        const y = d3.scale.linear()
            .range([0, height]);

        const x = d3.scale.ordinal();


        const svg = d3.select(this.target).append('svg')
            .attr('width', width + this.margin.right + this.margin.left)
            .attr('height', height + this.margin.top + this.margin.bottom)
            .append('g')
            .attr('transform', `translate(${this.margin.left},${this.margin.top})`);

        // Set the scale domain.
        const ymin = Math.min(0, d3.min(this.data, function (d) {
            return d.value;
        }));
        const ymax = Math.max(0, d3.max(this.data, function (d) {
            return d.value;
        }));

        //ymin = Math.floor(ymin);
        //ymax = Math.floor(ymax);

        y.domain([ymin, ymax]);
        x.domain(this.data.map(function (d) {
            return d.companyId;
        }));
        x.rangeBands([0, width], 0.2, 0.2);
        const key = function (d) {
            return d.companyId;
        };
        const val = function (d) {
            return d.value;
        };

        const bar = svg.selectAll('g.bar')
            .data(this.data, key)
            .enter().append('g')
            .attr('transform', function (d) {
                return `translate(${x(key(d))},0)`;
            });
        const fnHeight = function (d) {
            return Math.abs(y(val(d)) - y(0)) + me.zeroThickness;
        };

        bar.append('rect')
            .attr('class', function (d) {
                if (d.focus) {
                    return 'x-focus';
                } else {
                    return 'x-regular';
                }
            })
            .attr('width', x.rangeBand())
            .attr('height', fnHeight)
            .attr('y', function (d) {
                let yv;
                if (val(d) >= 0) {
                    yv = height - y(0) - fnHeight(d);
                } else {
                    yv = height - y(0);
                }
                return yv;
            });

        let youX = null;
        let youY = null;

        let focusData = _.find(this.data, function (item) {
            return item.focus;
        });
        if (typeof focusData === 'undefined') {
            focusData = [];
        }
        const text = svg.selectAll('text')
            .data([focusData], key)
            .enter().append('g');

        const line = d3.svg.line()
            .x(function (d) {
                return d.x;
            })
            .y(function (d) {
                return d.y;
            });

        let youLine = [];

        if (this.shouldRenderAxis) {
            const labelPoints = [
                0
            ];
            if (ymin < 0 && Math.abs(y(ymin) - y(0)) > 20) {
                labelPoints.push(ymin);
            }
            if (ymax > 0 && Math.abs(y(ymax) - y(0)) > 20) {
                labelPoints.push(ymax);
            }
            const labels = svg.selectAll('g.labels')
                .data(labelPoints, key)
                .enter().append('g');
            labels.append('text')
                .attr('x', 0)
                .attr('y', function (d) {
                    let yv;

                    if (d >= 0) {
                        yv = height - y(d);
                    } else {
                        yv = height - y(d);
                    }
                    return yv;
                })
                .attr('font-size', '10px')
                .attr('text-anchor', 'end')
                .attr('dominant-baseline', 'middle')
                .text(function (d) {
                    return me.formatY(d);
                });
            this.data.forEach(function (d) {
                if (d.focus) {
                    if (val(d) < 0) {
                        youY = height - y(0) - 2;
                    } else {
                        youY = height - y(val(d)) - 2;
                    }

                    youX = x(key(d)) + x.rangeBand() / 2 - 2;
                }
            });


            youLine.push({
                x: width - 10,
                y: -5
            });
            youLine.push({
                x: youX,
                y: youY
            });
            svg.append('path')
                .attr('class', 'line')
                .attr('d', line(youLine));
            text.append('text')
                .attr('class', function () {
                    return 'value-outside';
                })
                .attr('x', width + 15)
                .attr('y', -15)
                .attr('dx', 0)
                .attr('dy', '1em')
                .attr('text-anchor', 'end')
                .text(function (d) {
                    let retval;
                    if (d.value !== null) {
                        retval = 'You';
                    }
                    return retval;
                });
        }
        if (this.shouldRenderYou) {
            youX = null;
            youY = null;
            this.data.forEach(function (d) {
                if (d.focus) {
                    if (val(d) > 0) {
                        youY = height - y(0) + 4;
                    } else {
                        youY = height - y(val(d)) + 4;
                    }

                    youX = x(key(d)) + x.rangeBand() / 2;
                }
            });
            const dYou = [
                {
                    x: youX,
                    y: youY
                }
            ];
            svg.selectAll('.dot')
                .data(dYou)
                .enter().append('circle')
                .attr('class', 'dot')
                .attr('cx', function (d) {
                    return d.x;
                })
                .attr('cy', function (d) {
                    return d.y;
                })
                .attr('r', 2);
            text.append('text')
                .attr('class', function () {
                    return 'value-outside';
                })
                .attr('x', youX)
                .attr('y', height + 5)
                .attr('dx', 0)
                .attr('dy', '1em')
                .attr('text-anchor', function () {
                    if (youX < width / 2) {
                        return 'start';
                    } else {
                        return 'end';
                    }
                })
                .text(function (d) {
                    let retval;
                    if (d.value !== null) {
                        retval = me.youText;
                    }
                    return retval;
                });
            youLine = [];
            youLine.push({
                x: youX,
                y: height + 5
            });
            youLine.push({
                x: youX,
                y: youY + 2
            });
            svg.append('path')
                .attr('class', 'line')
                .attr('d', line(youLine));
            if (!this.hasrendered) {
                d3.select(this.target).on('mouseout', function () {
                    me.inMouseover = false;
                    me.mouseOverCompany = null;

                    d3.select(me.target).selectAll('.x-popup-label').remove();
                    d3.select(me.target)
                        .selectAll('svg g rect')
                        .attr('class', function (d) {
                            if (d.focus) {
                                return 'x-focus';
                            } else {
                                return 'x-regular';
                            }
                        });
                });
                d3.select(this.target).on('click', function () {
                    if (me.mouseOverCompany && !isReadOnly) {
                        window.location = `/company/${me.mouseOverCompany.companyId}`;
                    }
                });

                d3.select(this.target).on('mousemove', function () {
                    const mouseX = d3.mouse(this)[0];

                    const xC = mouseX - me.margin.left;
                    let ind = d3.bisect(x.range(), xC) - 1;


                    if (ind < 0) {
                        ind = 0;
                    }
                    if (ind > me.data.length) {
                        ind = me.data.length - 1;
                    }

                    if (xC < x(me.data[0].companyName)) {

                        d3.select(me.target).selectAll('.x-popup-label').remove();

                        d3.select(me.target)
                            .selectAll('svg g rect')
                            .attr('class', function (d) {
                                if (d.focus) {
                                    return 'x-focus';
                                } else {
                                    return 'x-regular';
                                }
                            });
                        me.inMouseover = false;
                        me.mouseOverCompany = null;
                        return;
                    }
                    if (xC > me.width - x.rangeBand() / 2) {
                        d3.select(me.target).selectAll('.x-popup-label').remove();
                        d3.select(me.target)
                            .selectAll('svg g rect')
                            .attr('class', function (d) {
                                if (d.focus) {
                                    return 'x-focus';
                                } else {
                                    return 'x-regular';
                                }
                            });
                        me.inMouseover = false;
                        me.mouseOverCompany = null;
                        return;
                    }
                    me.mouseOverCompany = me.data[ind];
                    d3.select(me.target).selectAll('.x-popup-label').remove();
                    d3.select(me.target).select('svg g').append('text')
                        .attr('class', 'x-popup-label')
                        .text(`${me.data[ind].companyName} (${me.formatY(me.data[ind].value)}) »`)
                        .attr('text-anchor', 'middle')
                        .attr('x', function () {
                            if (mouseX < width / 2) {
                                return mouseX + 10;
                            } else {
                                return mouseX - 10;
                            }
                        })
                        .attr('y', -2)
                        .attr('text-anchor', function () {
                            if (mouseX < width / 2) {
                                return 'start';
                            } else {
                                return 'end';
                            }
                        });
                    d3.select(me.target)
                        .selectAll('svg g rect')
                        .attr('class', function (d, i) {
                            if (i === ind) {
                                return 'x-focus';
                            } else {
                                return 'x-regular';
                            }
                        });
                    me.inMouseover = true;
                    me.mouseOverCompany = me.data[ind];

                    //d3.selectAll('rect').transition().style("color", "black");

                });
            }
            this.hasrendered = true;

        }


    };

}, window.d3);
